import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        position: 'relative',
        px: 3,
      }}
    >
      {/* Big centered icon */}
      <SearchOffIcon
        sx={{
          fontSize: 160,
          color: 'text.disabled',
          opacity: 0.35,
        }}
      />

      {/* Text anchored near the bottom */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 64,
          left: 0,
          right: 0,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: 'text.disabled', fontWeight: 500, letterSpacing: 0.2 }}
        >
          We could not find this page
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFoundPage;